import { useQuery } from 'react-query';
import {
  getRosterQualifications,
  RosterQualificationsByCostCenterAndDate
} from 'RestAPIs/qualifications';

const useGetRosterQualifications = ({
  costCenterId,
  startDate,
  endDate
}: RosterQualificationsByCostCenterAndDate) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['rosterQualifications', 'list', costCenterId, startDate, endDate],
    async () => {
      const { data } = await getRosterQualifications({
        costCenterId,
        startDate,
        endDate
      });
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetRosterQualifications;
